module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Commode1-db4bf5c8b115934ef9c9f07abad2f2bd.svg";